import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import {
    StoreType,
    ChangeUserSettings,
    updateUserSettings,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    LabelValue,
    Input,
    Collapse,
} from "client/components"

import FormatPercentage from "client/pages/sil/format/percentage"
import { customParseInt, customParseFloat } from "client/pages/sil/format/parse"


const VdiVde21802019 = () => {
    const settings = useSelector((state: StoreType) => state.userSettings.settings.sil)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (value: ChangeUserSettings) => {
        dispatch(updateUserSettings("sil", value))
    }

    const { vdivde21802019 } = settings
    const {
        ptc0A,
        ptc1A,
        ptc0B,
        ptc1B,
        ptc0C,
        ptc1C,
        beta,
        t0,
        t1,
        t2,
    } = vdivde21802019

    return (
        <Collapse
            show={show}
            title={lang.defaultVdiVde_2180_2019_settings}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <Row>
                    <Col xs={6}>
                        <FormatPercentage
                            title={lang.defaultPtc0A}
                            data={ptc0A}
                            onChange={(value) => onChange({
                                vdivde21802019: {
                                    ...vdivde21802019,
                                    ptc0A: customParseFloat(value),
                                },
                            })}
                        />
                    </Col>
                    <Col xs={6}>
                        <FormatPercentage
                            title={lang.defaultPtc1A}
                            data={ptc1A}
                            onChange={(value) => onChange({
                                vdivde21802019: {
                                    ...vdivde21802019,
                                    ptc1A: customParseFloat(value),
                                },
                            })}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <FormatPercentage
                            title={lang.defaultPtc0B}
                            data={ptc0B}
                            onChange={(value) => onChange({
                                vdivde21802019: {
                                    ...vdivde21802019,
                                    ptc0B: customParseFloat(value),
                                },
                            })}
                        />
                    </Col>
                    <Col xs={6}>
                        <FormatPercentage
                            title={lang.defaultPtc1B}
                            data={ptc1B}
                            onChange={(value) => onChange({
                                vdivde21802019: {
                                    ...vdivde21802019,
                                    ptc1B: customParseFloat(value),
                                },
                            })}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <FormatPercentage
                            title={lang.defaultPtc0C}
                            data={ptc0C}
                            onChange={(value) => onChange({
                                vdivde21802019: {
                                    ...vdivde21802019,
                                    ptc0C: customParseFloat(value),
                                },
                            })}
                        />
                    </Col>
                    <Col xs={6}>
                        <FormatPercentage
                            title={lang.defaultPtc1C}
                            data={ptc1C}
                            onChange={(value) => onChange({
                                vdivde21802019: {
                                    ...vdivde21802019,
                                    ptc1C: customParseFloat(value),
                                },
                            })}
                        />
                    </Col>
                </Row>

                <FormatPercentage
                    title={lang.defaultBeta}
                    data={beta}
                    onChange={(value) => onChange({
                        vdivde21802019: {
                            ...vdivde21802019,
                            beta: customParseFloat(value),
                        },
                    })}
                />

                <FormGroup>
                    <Label>
                        {lang.defaultT0}
                        <LabelValue>{lang.hoursLabel}</LabelValue>
                    </Label>
                    <Input
                        type="text"
                        value={t0}
                        onChange={(e) => onChange({
                            vdivde21802019: {
                                ...vdivde21802019,
                                t0: e.target.value,
                            },
                        })}
                        onBlur={(e) => onChange({
                            vdivde21802019: {
                                ...vdivde21802019,
                                t0: customParseInt(e.target.value),
                            },
                        })}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>
                        {lang.defaultT1}
                        <LabelValue>{lang.hoursLabel}</LabelValue>
                    </Label>
                    <Input
                        type="text"
                        value={t1}
                        onChange={(e) => onChange({
                            vdivde21802019: {
                                ...vdivde21802019,
                                t1: e.target.value,
                            },
                        })}
                        onBlur={(e) => onChange({
                            vdivde21802019: {
                                ...vdivde21802019,
                                t1: customParseInt(e.target.value),
                            },
                        })}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>
                        {lang.defaultT2}
                        <LabelValue>{lang.hoursLabel}</LabelValue>
                    </Label>
                    <Input
                        type="text"
                        value={t2}
                        onChange={(e) => onChange({
                            vdivde21802019: {
                                ...vdivde21802019,
                                t2: e.target.value,
                            },
                        })}
                        onBlur={(e) => onChange({
                            vdivde21802019: {
                                ...vdivde21802019,
                                t2: customParseInt(e.target.value),
                            },
                        })}
                    />
                </FormGroup>
            </PageForm>
        </Collapse>
    )
}
export default VdiVde21802019
